import {useContext, useEffect} from 'external/react'
import {FAIcon} from 'external/material'
import {logout} from 'context/post'
import {subdomainResource, viewerGuard} from 'helpers/url'
import SelectLanguage from '../select-language'
import SwitchView from '../switch-view'
import Notification from './Notification'

import { TeacherContext } from 'teacher/context'

import './topbar.styl'



function handleLogout (language, project) {
  return async () => {
    await logout()
    const url = subdomainResource(project == 'de' ? 'de' : 'www',language, 'login.html')
    location.replace(`//${url}`)
  }
}

export default function Topbar() {
    const context = useContext(TeacherContext)
    const {locked, profile, menuShowing, languageId, role, link, settings, translate, updateState} = context
    const {individual = {}, institution} = profile
    const addresses = individual.addresses || {}
    const informed = addresses.uiInformed
    const {properties, loaded} = context.preferences

    function hide ({target}) {
      if (!target) return
      if (target.id == 'menu') return
      if (target.closest('.menu-button')) return
      if (target.closest('#more-menu')) return
      if (target.closest('.submenu')) return
      document.removeEventListener("click", hide)
      updateState({menuShowing: {$set: false}, expandedMenuShowing: {$set: false} })
    }

    function toggle () {
      updateState({menuShowing: {$apply: showing => !showing}})
    }

    useEffect(() => {
      if (menuShowing) {
        document.addEventListener('click', hide)
      } else {
        document.removeEventListener('click', hide)
      }
    }, [menuShowing])


    const notificationOpened = loaded
      ? !properties.notifications[settings.showTopbarNotification]
      : false

    return (
      <header className="topbar">
        {!locked && ( 
          <button
            className="menu-button"
            onClick= {toggle}>
            <i>
              <FAIcon icon='bars' />
            </i>
          </button>
        )}
        <div className="title-wrapper">
          <label className="title">
            {translate(`${profile.institution.project}_project_title`)}
          </label>
        </div>
        <SelectLanguage />
        <button className="logout" onClick={handleLogout(languageId, institution.project)}>
          {translate('logout')}
        </button>
        {false && <SwitchView informed={informed} />}
        <a {...{...viewerGuard({href: 'https://edusystem.com/uso-y-manejo-maestros/', target: "_blank"}), className: 'help'}}>
          <i>
            <FAIcon icon='questionCircle' />
          </i>
        </a>
        {settings.showTopbarNotification && (<Notification notificationPrefix={settings.showTopbarNotification} open={notificationOpened} context={context} />)}
      </header>
    )
}
